module.exports = __webpack_public_path__ + "img/ton_handschrift_01.eb6fecfe.png";